export const PUBLICATION_STATUS_LABELS: any = {
    published: {
        label: "Publicado"
    },
    inspection: {
        label: "Inspección"
    },
    match: {
        label: "Match"
    },
    linze_visit: {
        label: "Visita de linze"
    },
    payment: {
        label: "Pago"
    },
    documentation_signature: {
        label: "Firma de doc."
    },
    delivered: {
        label: "Entregado"
    },
    sold_out: {
        label: "Vendido"
    },
    pending: {
        label: "Pendiente"
    },
    rejected: {
        label: "Rechazado"
    }
};

export const TRANSACTIONS_STATUS_LABELS: any = {
    pending: {
        label: "Pendiente"
    },
    in_progress: {
        label: "En progreso"
    },
    finished: {
        label: "Finalizado"
    },
    cancelled: {
        label: "Cancelado"
    }
};

export const PUBLICATIONS_DROPDOWN_TEXTS: any = {
    published: 'Cuando un usuario quiere vender su vehículo, lo publica en la plataforma para que otros interesados puedan interactuar, ya sea mediante una oferta de compra o directamente comprarlo.',
    inspection: 'El linzer se encuentra con el vendedor, válida su identidad y realiza la inspección correspondiente para asegurarse de que el vehículo está en las condiciones acordadas o aceptables para continuar con la transacción.',
    match: 'Cuando un interesado hace una oferta para comprar un vehículo, el vendedor evalúa la propuesta y, si está de acuerdo, se produce un "match" o coincidencia entre el comprador y el vendedor para continuar con la transacción.',
    linze_visit: 'Después de que se haya hecho el "match" y la compra haya sido aprobada, un linzer se encuentra en camino hacia la ubicación del vendedor para realizar la inspección del vehículo.',
    payment: 'Una vez que el vendedor ha firmado la documentación necesaria, se procede a realizar el pago correspondiente. En este momento, el pago está pendiente de ser realizado.',
    documentation_signature: 'Después de que el linzer ha inspeccionado el vehículo y todo está en orden, el vendedor debe firmar la documentación necesaria para finalizar completamente la transacción. En este momento, la documentación se encuentra pendiente de ser firmada.',
    delivered: 'Una vez que se ha completado el proceso con el vendedor y se ha obtenido la aprobación, el linzer se lleva el vehículo junto al comprador para finalizar la transacción.',
    sold_out: 'El linzer ha finalizado el proceso con el comprador y ha entregado el vehículo, lo que significa que la transacción se ha completado y el vehículo ya no está disponible para la venta.',
    pending: 'Despues de publicar un vehículo, se debe esperar a que el manager valide las fotos e información de la publicación',
    rejected: ''
}

export const TRANSACTIONS_DROPDOWN_TEXTS: any = {
    pending: 'Cuando un comprador muestra interés en comprar un vehículo, envía una propuesta de compra al vendedor. En este estado, la transacción está en espera de que el vendedor tome una decisión sobre la oferta.',
    in_progress: 'Una vez que el vendedor ha revisado y aceptado la propuesta de compra del comprador, lo que indica que ambas partes han acordado seguir adelante con la compra.',
    finished: 'Cuando la transacción ha sido completada con éxito y todos los aspectos del acuerdo han sido cumplidos, indicando que la compra se ha realizado de manera satisfactoria.',
    cancelled: 'Si en algún punto del proceso de compra y venta surge un inconveniente o se toma la decisión de no continuar con la transacción. Esto puede deberse a diversas razones, como desacuerdos en el precio, problemas en la inspección del vehículo o cambios de decisión por parte del comprador o vendedor.'
};